import { render, staticRenderFns } from "./insert.vue?vue&type=template&id=f3f89778&scoped=true&"
import script from "./insert.vue?vue&type=script&lang=js&"
export * from "./insert.vue?vue&type=script&lang=js&"
import style0 from "./insert.vue?vue&type=style&index=0&id=f3f89778&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f89778",
  null
  
)

export default component.exports